(function () {
  'use strict';

  /*
   * Retail Cloud Connect (Nimstrata) dynamic autocomplete locks page scroll by adding
   * `rcc-dynamic-scroll-locked` (overflow: hidden) to <html> and <body> while it is open.
   * iOS Safari ignores overflow: hidden for touch scrolling, so the page behind the panel
   * still scrolls. On touch devices, pin <body> at its current offset while the class is
   * present and restore the scroll position when it is removed.
   */
  const LOCK_CLASS = 'rcc-dynamic-scroll-locked';
  const root = document.documentElement;
  const touchQuery = window.matchMedia('(pointer: coarse)');
  let lockedScrollY = null;

  function lock() {
    if (lockedScrollY !== null) return;

    lockedScrollY = window.scrollY;
    const style = document.body.style;
    style.position = 'fixed';
    style.top = `-${lockedScrollY}px`;
    style.left = '0';
    style.right = '0';
  }

  function unlock() {
    if (lockedScrollY === null) return;

    const scrollY = lockedScrollY;
    lockedScrollY = null;
    ['position', 'top', 'left', 'right'].forEach((property) => document.body.style.removeProperty(property));
    window.scrollTo({ top: scrollY, behavior: 'instant' });
  }

  function sync() {
    if (root.classList.contains(LOCK_CLASS) && touchQuery.matches) {
      lock();
    } else {
      unlock();
    }
  }

  new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['class'] });
  sync();
})();
